module.exports = __webpack_public_path__ + "img/luna_mia.53db302b.png";